"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Loading = void 0;
var _mui = require("@ori-ui/mui");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const Root = (0, _mui.styled)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center'
});
const Loading = exports.Loading = /*#__PURE__*/ (0, _react.memo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.CircularProgress, {
            color: "primary"
        })
    }));
